import PropTypes from 'prop-types';
import * as React from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const avatarPropTypes = {
    /**
   * The size variation
   */ size: PropTypes.oneOf([
        'standard',
        'mini'
    ]),
    /**
   * URL of the avatar image
   */ src: PropTypes.string,
    /**
   * A label to use to describe the avatar to assistive devices.
   */ alt: PropTypes.string
};
const propKeysToRemove = Object.keys(avatarPropTypes);
const Avatar = renderWithRef('Avatar', avatarPropTypes, (props, ref)=>{
    useComponentStylesLoaded('Avatar', SWAN_STYLE_KEY_MAP.avatar);
    const { src, alt, size = 'standard' } = props;
    const classNames = new Set([
        'swan-avatar'
    ]);
    if (size === 'mini') classNames.add(`swan-avatar-${size}`);
    const avatarProps = _object_spread_props(_object_spread({}, props), {
        style: {
            '--swan-internal-avatar-image': src ? `url(${src})` : null
        }
    });
    if (alt) {
        avatarProps['role'] = 'img';
        avatarProps['aria-label'] = alt;
    }
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: _object_spread({}, avatarProps)
    });
});

export { Avatar, avatarPropTypes };
